import { useEffect } from 'react';
import './DragonbreathAnimation.css';

export default function DragonbreathAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const p = playerEl.getBoundingClientRect();
    const o = opponentEl.getBoundingClientRect();

    const dx = (o.left + o.width / 2) - (p.left + p.width / 2);
    const dy = (o.top + o.height / 2) - (p.top + p.height / 2);
    const fullLen = Math.hypot(dx, dy);
    const angle = Math.atan2(dy, dx) * 180 / Math.PI;

    const container = playerEl.parentElement;
    const contRect = container.getBoundingClientRect();
    const startX = (p.left + p.width / 2) - contRect.left;
    const startY = (p.top + p.height / 2) - contRect.top;

    const endX = (o.left + o.width / 2) - contRect.left;
    const endY = (o.top + o.height / 2) - contRect.top;

    // Pulse at mouth
    const pulse = document.createElement('div');
    pulse.className = 'dragonbreath-pulse';
    pulse.style.left = `${startX - 32}px`;
    pulse.style.top = `${startY - 32}px`;
    container.appendChild(pulse);
    setTimeout(() => pulse.remove(), 400);

    // Beam segments
    const segmentCount = 4;
    const segmentLength = fullLen * 0.5;
    const spacing = (fullLen - segmentLength) / (segmentCount - 1);

    const beams = [];
    for (let i = 0; i < segmentCount; i++) {
      const t = (spacing * i) / fullLen;
      const offsetX = dx * t;
      const offsetY = dy * t;

      const beam = document.createElement('div');
      beam.className = 'dragonbreath-beam';
      beam.style.left = `${startX + offsetX}px`;
      beam.style.top = `${startY + offsetY - 72}px`; // center on path
      beam.style.width = `${segmentLength}px`;
      beam.style.setProperty('--angle', `${angle}deg`);
      container.appendChild(beam);
      beams.push(beam);
    }

    // Impact burst
    const impact = document.createElement('div');
    impact.className = 'dragonbreath-impact';
    impact.style.left = `${endX - 64}px`;
    impact.style.top = `${endY - 64}px`;
    container.appendChild(impact);
    setTimeout(() => impact.remove(), 400);

    // Fade beams
    setTimeout(() => {
      beams.forEach((b) => b.classList.add('fadeout'));
    }, 900);

    // Cleanup
    const timer = setTimeout(() => {
      beams.forEach((b) => b.remove());
      onComplete();
    }, 1200);

    return () => {
      clearTimeout(timer);
      beams.forEach((b) => b.remove());
      impact.remove();
      pulse.remove();
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

DragonbreathAnimation.moveType = 'dragon';
